
import React from 'react';
import Hero from '@/components/Hero';
import BlogList from '@/components/blog/BlogList';
import BlogHeader from '@/components/blog/BlogHeader';
import BlogSearchBar from '@/components/blog/BlogSearchBar';
import BlogEmptyState from '@/components/blog/BlogEmptyState';
import { BlogPost } from '@/components/blog/types';

interface BlogListingProps {
  blogPosts: BlogPost[];
  searchQuery: string;
  filteredPosts: BlogPost[];
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPostClick: (post: BlogPost) => void;
  onClearSearch: () => void;
}

const BlogListing: React.FC<BlogListingProps> = ({
  blogPosts,
  searchQuery,
  filteredPosts,
  onSearchChange,
  onPostClick,
  onClearSearch
}) => {
  return (
    <>
      <Hero
        title="Discover NYC's Feline History"
        subtitle="Stories from historic walking tours, NYC's famous cats, and more feline adventures throughout the city"
        backgroundImage="/lovable-uploads/0390c64c-61a9-4a20-8c0a-ad3de146e1c9.png"
        height="medium"
        imageStyle="natural"
        contentPosition="center"
        imagePosition="top"
        overlay={false}
      />
      <div className="bg-[#FDF6ED] py-12">
        <div className="container mx-auto px-4 animate-fadeIn transition-opacity duration-500">
          <div className="max-w-7xl mx-auto">
            <BlogHeader 
              title="Blog & Cat Stories" 
              description="Explore our collection of articles about New York City's fascinating feline history, walking tour experiences, and the unique stories of cats who shaped the city."
            />

            <BlogSearchBar
              searchQuery={searchQuery}
              onSearchChange={onSearchChange}
              filteredPosts={filteredPosts}
            />

            {filteredPosts.length > 0 ? (
              <BlogList blogPosts={filteredPosts} onPostClick={onPostClick} />
            ) : searchQuery ? (
              <BlogEmptyState searchQuery={searchQuery} onClearSearch={onClearSearch} />
            ) : (
              <BlogEmptyState />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogListing;
